import type { ReactElement } from 'react'

import {
  BulletedList,
  BulletedListItem,
} from '@twisto/components/molecules/list'

import * as styles from './intro-step-content-bullet-list.styles'

type Props = {
  items: Array<{
    icon: ReactElement
    text: ReactElement
  }>
}
export const IntroStepContentBulletList = ({ items }: Props) => (
  <BulletedList css={styles.list}>
    {items.map(({ icon, text }, index) => (
      <BulletedListItem key={index} customIcon={icon}>
        {text}
      </BulletedListItem>
    ))}
  </BulletedList>
)
